import type { CreateMemoryInput, MediaAsset, Memory, MemoryWithMedia } from "@memory-universe/domain";
import type { PreparedMemoryMedia } from "../../../shared/platform/localOriginalMedia";

export interface CreateMemoryCommand {
  galaxyId: string;
  input: CreateMemoryInput;
  media: PreparedMemoryMedia[];
}

export type RecentlyDeletedItem =
  | {
      kind: "memory";
      memory: Memory;
      deletedAt: string;
      mediaCount: number;
    }
  | {
      kind: "media";
      memoryId: string;
      memoryTitle: string;
      occurredAt: string;
      media: MediaAsset;
      deletedAt: string;
    };

export interface MemoryRepository {
  list(galaxyId: string): Promise<MemoryWithMedia[]>;
  get(memoryId: string): Promise<MemoryWithMedia | null>;
  create(command: CreateMemoryCommand): Promise<MemoryWithMedia>;
  softDeleteMemory(memoryId: string): Promise<void>;
  softDeleteMemoryMedia(memoryId: string, mediaId: string): Promise<void>;
  listRecentlyDeleted(galaxyId: string): Promise<RecentlyDeletedItem[]>;
  restoreMemory(memoryId: string): Promise<void>;
  restoreMemoryMedia(memoryId: string, mediaId: string): Promise<void>;
}

export function releaseMemoryUrls(memories: MemoryWithMedia[]) {
  for (const item of memories) {
    for (const media of item.media) {
      URL.revokeObjectURL(media.url);
    }
  }
}
